require('/opt/odin/app/frontend/components/cookies_agreement/index.module.scss');module.exports = "../../app/cells/components/cookies_agreement/show.erb";